'use client';

import { c as _c } from "react/compiler-runtime";
import { Avatar as AvatarBase, type AvatarProps } from '@shared/ui-components/avatar/avatar';
import { imageLoader } from '../image-wrapper/image-loader';
export const Avatar = props => {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <AvatarBase {...props} loader={imageLoader} />;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};